import { useEffect, useMemo, useRef, useState } from "react";
import notificationsIcon from "./notifications.svg";
import { NotificationData, services } from "./utils";
import { Box, ButtonBase } from "@mui/material";
import { readDataStorage } from "../../utils/storage/storage";

// ----------------------------------------------------------------------

const REFRESH_NOTIFICATIONS_INTERVAL = 1000 * 60 * 2;

// ----------------------------------------------------------------------

type NotificationsButtonProps = {
  primary?: boolean;
  small?: boolean;
  style?: React.CSSProperties;
};

export function NotificationsButton({ style }: NotificationsButtonProps) {
  const { CpfRepresentante } = readDataStorage("login");
  const [notifications, setNotifications] = useState<NotificationData[]>([]);

  const openNotifications = () => {
    window.open("/arp/notifications", "_blank")?.focus();
  };

  const unreadNotifications = useMemo(
    () => notifications.filter((item) => !item.read),
    [notifications]
  );

  // ----------------------------------------------------------------------

  const refreshNotifications = async () => {
    try {
      await services.listNotifications(CpfRepresentante).then(setNotifications);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    refreshNotifications();

    const interval = setInterval(
      refreshNotifications,
      REFRESH_NOTIFICATIONS_INTERVAL
    );
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ----------------------------------------------------------------------

  const animationRef = useRef<HTMLDivElement>(null);

  const animate = () => {
    if (!unreadNotifications.length) return;

    if (animationRef.current) {
      animationRef.current.style.animation = "spin 1s linear";
      setTimeout(() => {
        if (animationRef.current) {
          animationRef.current.style.animation = "";
        }
      }, 2000);
    }
  };

  useEffect(() => {
    animate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unreadNotifications]);

  // ----------------------------------------------------------------------

  return (
    <ButtonBase
      onClick={openNotifications}
      style={{
        position: "relative",
        padding: 8,
        borderRadius: 999,
        width: 36,
        height: 36,
        ...style,
      }}
    >
      <Box
        ref={animationRef}
        sx={{
          transformOrigin: "top",
          // animation: "spin 1s linear",
          "@keyframes spin": {
            "0%": { transform: "rotate(360deg)" },
            "5%": { transform: "rotate(45deg)" },
            "20%": { transform: "rotate(-45deg)" },
            "35%": { transform: "rotate(45deg)" },
            "50%": { transform: "rotate(-45deg)" },
            "65%": { transform: "rotate(45deg)" },
            "80%": { transform: "rotate(-45deg)" },
            "95%": { transform: "rotate(-8deg)" },
            "100%": { transform: "rotate(0deg)" },
          },
        }}
      >
        <img
          src={notificationsIcon}
          alt="Notificações"
          style={{ width: 24, height: 24 }}
        />
      </Box>

      {!!unreadNotifications.length && (
        <div
          style={{
            position: "absolute",
            top: -4,
            right: 0,
            borderRadius: 999,
            backgroundColor: "white",
            width: 16,
            height: 16,
          }}
        >
          <p
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: "#6c5af4",
              marginTop: -1,
            }}
          >
            {unreadNotifications.length}
          </p>
        </div>
      )}
    </ButtonBase>
  );
}
